// this is where our sanity client will connect with our react app

import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

//get these by sanity manage command
export const client = sanityClient({
    projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
    dataset: process.env.REACT_APP_SANITY_DATASET,
    apiVersion: '2022-02-01',
    useCdn: true,
    token: process.env.REACT_APP_SANITY_TOKEN,
})

//whenever we want to use images from sanity, we need to use this function
const builder = imageUrlBuilder(client); //useful for our images

export const urlFor = (source) => builder.image(source) //useful for our images